import "./BotaoExportar.css"

export default function BotaoExportar(props) {
    return (
        <button className="botao-exportar" onClick={props.onClick}  >
            {props.endIcon}
            <div className="botao-title">{props.title}</div>              
        </button>
    )
}